import { render, staticRenderFns } from "./OptionRadio.vue?vue&type=template&id=420ca514&scoped=true&"
import script from "./OptionRadio.vue?vue&type=script&lang=js&"
export * from "./OptionRadio.vue?vue&type=script&lang=js&"
import style0 from "./OptionRadio.vue?vue&type=style&index=0&id=420ca514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ca514",
  null
  
)

export default component.exports